import script from "./QueueProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./QueueProgress.vue?vue&type=script&setup=true&lang=js"

import "./QueueProgress.vue?vue&type=style&index=0&id=168ee278&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-168ee278"]])

export default __exports__